import {
    renderFpsrThumbnailFile,
    type FpsrRenderOptions,
} from '@/lib/fpsr';
import { useMutation } from '@tanstack/react-query';

type RenderFpsrInput = Omit<FpsrRenderOptions, 'maxOutputSize'> & {
  maxOutputSize?: FpsrRenderOptions['maxOutputSize'];
};

export function useRenderFpsr() {
  return useMutation({
    mutationFn: (input: RenderFpsrInput) => renderFpsrThumbnailFile(input),
    onError: error => {
      console.error('FPSR render error:', error);
    },
  });
}
